import { createFileRoute, Outlet } from "@tanstack/react-router"
import { getAppChrome, requireUserId } from "@/auth/rpc"
import { SuppliesNav } from "../components/supplies-nav"

export const Route = createFileRoute("/_supplies-layout")({
  beforeLoad: async () => {
    await requireUserId({ data: { redirectTo: "/supplies" } })
  },
  loader: () => getAppChrome(),
  component: SuppliesLayout,
})

function SuppliesLayout() {
  const { sisterAppUrl } = Route.useLoaderData()

  return (
    <div className="min-h-screen bg-background text-foreground">
      <SuppliesNav sisterAppUrl={sisterAppUrl} />
      <main className="container mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  )
}
